<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="抖音号">
        <el-input
          v-model="formLabelAlign.dy_id"
          style="width: 700px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="cookie名称">
        <el-input
          v-model="formLabelAlign.cookie"
          style="width: 700px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { operateCookiestore } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        dy_id: '',
        cookie: ''
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbit() {
      if (this.formLabelAlign.dy_id === '') {
        this.$message.error('请输入抖音号')
        return
      }
      if (this.formLabelAlign.cookie === '') {
        this.$message.error('请输入cookie')
        return
      }
      operateCookiestore(this.formLabelAlign).then(res => {
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('updata')
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
